export default {
  login: {
    title: '登錄',
    usernameLabel: '用戶名',
    usernamePlaceholder: '2-10位以英文開頭的英文數字組合',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入你的登錄密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    hasNoAccount: '還沒有賬號,',
    goRegister: '去註冊',
    onlineCustom: '在線客服',
    loginArgument: '繼續登錄即代表同意',
    userArgument: '《用戶協議》',
    registerNotEnabled: '未開放註冊功能, 請聯繫管理員',
    usernameRequired: '請輸入正確的用戶名',
    loginPasswordRequired: '請輸入正確的登錄密碼',
    googleCodeRequired: '請輸入正確的谷歌驗證碼',
    loginButton: '登錄'
  },
  register: {
    title: '註冊',
    usernameLabel: '用戶名',
    usernamePlaceholder: '請輸入註冊的用戶名',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入註冊用戶的登錄密碼',
    loginPasswordPreLabel: '確認登錄密碼',
    loginPasswordPrePlaceholder: '請再次輸入登錄密碼',
    fudPasswordLabel: '資金密碼',
    fudPasswordPlaceholder: '請輸入資金密碼',
    inviteCodeLabel: '邀請碼',
    inviteCodePlaceholder: '請輸入6位數邀請碼',
    registerNeed: '繼續註冊代表同意',
    registerArgument: '《註冊協議》',
    usernameRequired: '請輸入正確的用戶名',
    loginPasswordRequired: '請輸入正確的登錄密碼',
    loginPasswordPreRequired: '請輸入正確的確認登錄密碼',
    fundPasswordRequired: '請輸入正確的資金密碼',
    inviteCodeRequired: '請輸入正確的邀請碼',
    diffLoginPasswordError: '兩次登錄密碼輸入不一致',
    registerSuccess: '註冊成功',
    registerButton: '註冊',
    emailLabel: '郵箱',
    emailPlaceholder: '請輸入你的郵箱地址',
    emailCodeLabel: '驗證碼',
    emailCodePlaceholder: '請輸入你的郵箱驗證碼',
    second: '秒',
    getEmailCodeButton: '獲取驗證碼',
    emailRequired: '請輸入正確的郵箱地址後重試',
    emailCodeRequired: '請輸入正確的郵箱驗證碼後重試'
  },
  home: {
    hotCoin: {
      title: '熱門交易',
      more: '更多'
    },
    poster: {
      title: '快捷充幣',
      enter: '立即進入>',
      subTitle: '支持BTC，USDT，ETH等'
    },
    quickMenus: {
      futuresTrading: '期貨交易',
      helpCenter: '幫助中心'
    },
    ranking: {
      increase: {
        title: '漲幅榜'
      },
      clinch: {
        title: '成交額榜'
      }
    }
  },
  tabBar: {
    home: '首頁',
    price: '行情',
    trade: '交易',
    fund: '資產',
    user: '我的'
  },
  currency: {
    favorite: '自選',
    allCurrency: '現貨',
    dayVol: '24H額',
    addFavor: '+ 添加自選'
  },
  trade: {
    bills: '訂單',
    todayOpen: '開盤',
    star: '自選',
    vol: '成交量',
    low: '最低',
    high: '最高',
    timing: '極速',
    spot: '期貨',
    buyMore: '買多',
    buyEmpty: '買空',
    indicator: '指標',
    indicatorSettings: '指標設置',
    balance: '我的餘額',
    fee: '服務費',
    ruleIdError: '請選擇到期時間',
    deleteFavoriteSuccess: '刪除自選幣成功',
    addFavoriteSuccess: '添加自選幣成功',
    buyIn: '買入',
    sellOut: '賣出',
    holding: '持倉',
    history: '歷史',
    spotOrderConfirm: {
      title: '確認買入',
      amountPlaceholder: '請輸入購買數量'
    },
    spotTradeOrder: {
      holding: {
        coin: '幣種',
        buyInAmountPrice: '買入總價/單價',
        buyInCount: '數量',
        actions: '操作',
        sellOut: '賣出',
        profit: '盈亏'
      }
    },
    orderConfirm: {
      title: '訂單確認',
      coinName: '幣種',
      direction: '方向',
      price: '現價',
      balance: '餘額',
      fee: '服務費',
      buyMoreLabel: '買多',
      buyEmptyLabel: '買空',
      buyQuantity: '買入數量',
      buyAmount: '購買金額',
      submit: '確認訂單'
    },
    kline: {
      open: '開:',
      close: '收:',
      change: '漲跌:'
    }
  },
  finance: {
    title: '金融'
  },
  allFinance: {
    title: '理財',
    all: '全部'
  },
  financeOrders: {
    title: '質押訂單',
    holdingLabel: '在持',
    historyLabel: '歷史',
    holding: {
      amount: '質押金額',
      rateStr: '收益金額/收益率',
      vcCount: '質押幣數量',
      cycle: '持倉週期',
      day: '天',
      calcStartDate: '起息日期',
      serviceAmount: '服務費',
      redeemOrder: '贖回'
    },
    history: {
      incomeAmount: '收益金額',
      rateStr: '收益率',
      amount: '質押金額',
      vcCount: '質押幣數量',
      calcStartDate: '起息日期',
      calcEndDate: '終息日期',
      cycle: '週期天數',
      serviceAmount: '服務費',
      day: '天'
    }
  },
  financeOrderBills: {
    title: '質押收益賬單',
    amount: '金額',
    balance: '餘額'
  },
  financeItem: {
    rateStr: '收益率',
    buyType: '買入類型',
    cycle: '週期天數',
    exchangeRate: '兌換匯率(虛擬幣兌換餘額)',
    day: '天',
    cycleType: '週期類型',
    serviceRateStr: '服務費率'
  },
  buyFinance: {
    title: '購買',
    rateStr: '收益率',
    name: '名稱',
    buyType: '買入類型',
    cycle: '週期天數',
    cycleType: '週期類型',
    exchangeRate: '兌換匯率(虛擬幣兌換餘額)',
    serviceRateStr: '服務費率',
    remark: '備註',
    buyAmountLabel: '買入金額 ({coin})',
    descriptionTitle: '產品說明',
    descriptionPart1: '1.本產品為非保本理財產品，市場波動可能導致本金損失，請謹慎投資.',
    descriptionPart2: '2.回款結算規則：',
    descriptionPart3: '如果結算價＜掛鉤價，到期後結算BTC；結算數量=投資金額*(1+天數*年化收益率/365).',
    descriptionPart4: '如果結算價≥掛鉤價，到期後結算USDT；結算數量=投資金額*掛鉤價*(1+天數*年化收益率/365）.',
    descriptionPart5: '3.實際年化收益率隨市場實時變動，請以實際買入成交為準.',
    descriptionPart6: '4.投資金額隨市場實時折算得出，請以實際買入成交為準.',
    descriptionPart7: '5.產品購買後可在我的持幣頁面進行查看，到期結束後回款會自動發放至現貨賬戶.',
    buyButton: '購買 [{coin}]'
  },
  fund: {
    description: '資產',
    recharge: '充幣',
    withdraw: '提幣',
    exchange: '劃轉',
    empty: '錢包空空 去'
  },
  userCenter: {
    lastLogin: '上次登錄',
    myTeam: '我的團隊',
    identity: '實名認證',
    zskAccount: '轉數快賬戶',
    walletAddress: '錢包地址',
    bankCard: '銀行賬戶',
    userBills: '帳變記錄',
    timingTradeOrder: '極速持倉',
    spotTradeOrder: '期貨持倉',
    contactTradeOrder: '合約持倉',
    userReport: '用戶報表',
    teamReport: '團隊報表',
    share: '我要分享',
    customer: '聯繫客服',
    helpCenter: '幫助中心',
    platform: '平台介紹',
    profit: '今日盈虧',
    balance: '我的餘額',
    withdraw: '提幣',
    recharge: '充幣',
    creditStoreLabel: '信用積分'
  },
  settings: {
    title: '設置',
    fundPassword: '資金密碼',
    googleValidator: '谷歌驗證器',
    editLoginPassword: '修改登錄密碼',
    switchLocale: '切換語言'
  },
  editFundPassword: {
    title: '修改資金密碼',
    currentPasswordLabel: '當前密碼',
    currentPasswordPlaceholder: '請輸入當前資金密碼',
    newPasswordLabel: '新密碼',
    newPasswordPlaceholder: '請輸入修改的資金密碼',
    prePasswordLabel: '確認密碼',
    prePasswordPlaceholder: '清再次輸入修改的資金密碼',
    tips: '資金密碼是進行交易的重要憑證, 清謹慎設置並牢記',
    currentPasswordRequired: '請輸入當前的資金密碼',
    newPasswordRequired: '請輸入要修改的資金密碼',
    prePasswordRequired: '請再次輸入要修改的資金密碼',
    prePasswordDiff: '兩次密碼輸入不一致'
  },
  bindFundPassword: {
    title: '綁定資金密碼',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入資金密碼',
    fundPasswordPreLabel: '確認密碼',
    fundPasswordPrePlaceholder: '請再次輸入資金密碼',
    fundPasswordRequired: '請輸入正確的資金密碼',
    fundPasswordPreRequired: '請輸入正確的確認密碼',
    fundPasswordDiff: '兩次密碼輸入不一致',
    bindSuccess: '資金密碼綁定成功',
    tips: '資金密碼是進行交易的重要憑證, 請謹慎設置並牢記'
  },
  editLoginPassword: {
    title: '修改登錄密碼',
    currentPasswordLabel: '當前密碼',
    currentPasswordPlaceholder: '請輸入當前登錄密碼',
    newPasswordLabel: '新密碼',
    newPasswordPlaceholder: '請輸入修改的登錄密碼',
    prePasswordLabel: '確認密碼',
    prePasswordPlaceholder: '清再次輸入修改的登錄密碼',
    tips: '登錄密碼是進行登錄認證等的重要憑證, 請謹慎設置並牢記',
    currentPasswordRequired: '請輸入當前的登錄密碼',
    newPasswordRequired: '請輸入要修改的登錄密碼',
    prePasswordRequired: '請再次輸入要修改的登錄密碼',
    prePasswordDiff: '兩次密碼輸入不一致'
  },
  bindGoogleValidator: {
    title: '綁定谷歌驗證器',
    qrCodeLabel: '二維碼',
    keyLabel: '密鑰',
    loginPasswordLabel: '登錄密碼',
    loginPasswordPlaceholder: '請輸入你的登錄密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    tipsPart1: '在應用商店搜索谷歌驗證器',
    tipsPart2: '使用谷歌驗證器掃描上圖二維碼, 或手動輸入密鑰進行綁定',
    tipsPart3: '在上方輸入6位谷歌驗證碼, 點擊確認提交',
    loginPasswordRequired: '請輸入登錄密碼',
    googleCodeRequired: '請輸入6位谷歌驗證碼'
  },
  walletAddress: {
    title: '錢包地址',
    add: '+ 添加錢包地址',
    remark: '備註',
    addButton: '添加錢包地址',
    tips: '若要修改或刪除地址信息，請聯繫客服'
  },
  addWalletAddress: {
    title: '添加錢包地址',
    vcChainNameIdLabel: '鏈類型',
    vcAccountLabel: '錢包地址',
    vcAccountPlaceholder: '請輸入錢包地址',
    remarkLabel: '備註',
    remarkPlaceholder: '請輸入備註內容',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入你的資金密碼',
    tips: '添加後的錢包地址不可修改, 請核實信息無誤',
    vcIdRequired: '請選擇正確的幣種',
    vcChainNameIdRequired: '請選擇正確的鏈類型',
    vcAccountRequired: '請輸入正確的錢包地址',
    fundPwdRequired: '請輸入正確的資金密碼',
    addSuccess: '錢包地址添加成功'
  },
  receiveWays: {
    title: '我的銀行卡',
    add: '+ 添加銀行卡',
    tips: '若要修改或者刪除銀行卡信息，請聯繫客服',
    addCardButton: '添加銀行卡'
  },
  zskAccount: {
    title: '轉數快賬戶',
    add: '+ 添加轉數快賬戶',
    tips: '若要修改或刪除賬戶信息, 請聯繫客服',
    addCardButton: '添加賬戶'
  },
  addZskAccount: {
    title: '新增轉數快賬戶',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '請輸入姓名',
    withdrawNameRequired: '姓名不允許為空',
    zskLabel: '轉數快',
    zskPlaceholder: '請輸入轉數快',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入你的資金密碼',
    tips: '請謹慎填寫添加賬戶的信息, 如因為信息填寫錯誤導致提現不到賬的問題, 公司概不負責'
  },
  addBankCard: {
    title: '新增銀行卡',
    withdrawNameLabel: '姓名',
    withdrawNamePlaceholder: '請輸入姓名',
    withdrawNameRequired: '姓名不允許為空',
    zskLabel: '轉數快',
    zskPlaceholder: '請輸入轉數快',
    zskRequired: '請輸入正確的轉數快',
    cardNumLabel: '銀行卡號',
    cardNumPlaceholder: '請輸入銀行卡號',
    branchLabel: '支行地址',
    branchPlaceholder: '請輸入銀行卡支行地址',
    fundPasswordLabel: '資金密碼',
    fundPasswordPlaceholder: '請輸入資金密碼',
    tips: '銀行卡是進行交易提現的重要數據, 請謹慎填寫, 如因卡信息填寫錯誤導致提現不到賬等問題, 公司概不負責。 ',
    backIdRequired: '請選擇開戶行',
    cardNumRequired: '請輸入正確的銀行卡號',
    fundPwdRequired: '請輸入正確的資金密碼',
    idCardPlaceholder: '請輸入身份證號',
    idCardLabel: '身份證號',
    idCardRequired: '請輸入正確的身份證號',
    cciPlaceholder: '請輸入銀行卡CCI',
    branchCodePlaceholder: '請輸入支行編號',
    branchCodeLabel: '支行編號',
    katakanaPlaceholder: '請輸入片假名',
    katakanaLabel: '片假名'
  },
  userBills: {
    title: '帳變記錄',
    vcName: '幣種',
    amount: '金額',
    balance: '餘額'
  },
  timingTradeOrder: {
    title: '極速交易訂單',
    waiting: {
      title: '在持訂單',
      amount: '金額',
      period: '週期',
      receivePrice: '買入價',
      settlement: '結算中'
    },
    history: {
      title: '歷史訂單',
      buyInClose: '買入價',
      saleOutClose: '賣出價'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: '用戶報表',
    profit: '盈利',
    timingTradeAmountFee: '極速交易下單/手續費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/手續費',
    withdrawInfo: '提現/手續費',
    exchangeInfo: '兌換/手續費'
  },
  userReportDay: {
    title: '用戶日報表',
    profit: '盈利',
    timingTradeAmountFee: '極速交易下單/手續費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/手續費',
    withdrawInfo: '提現/手續費',
    exchangeInfo: '兌換/手續費'
  },
  teamReport: {
    title: '團隊報表',
    goToReportDay: '查看日報表',
    timingTradeBetAmountServiceCharge: '極速交易下單/服務費',
    timingTradeBetPrizePoint: '極速交易獎金/返點',
    timingTradeUserAndCount: '極速交易人數/筆數',
    rechargeAmountFee: '充值金額/服務費',
    rechargePersonCount: '充值人數/筆數',
    withdrawAmountFee: '提幣金額/服務費',
    withdrawPersonCount: '提幣人數/筆數',
    firstRechargeUserAndCount: '首充金額/人數',
    usernamePlaceholder: '輸入下級用戶名',
    previewAllTradeInfo: '查看所有極速交易信息',
    coin: '幣種',
    timingTradeBetAmount: '極速交易投注金額',
    profit: '盈利',
    action: '操作',
    previewReportDay: '查看日報表'
  },
  teamTimingTradeInfo: {
    title: '團隊極速交易',
    profit: '盈利',
    subTitle: '團隊極速交易信息',
    timingTradeAmountFee: '極速交易下單/服務費',
    timingTradePrizePoint: '極速交易獎金/返點',
    rechargeInfo: '充值/服務費',
    withdrawInfo: '提現/服務費',
    exchangeInfo: '兌換/服務費'
  },
  teamReportDay: {
    title: '團隊日報表',
    subTitle: '團隊 [ {username} ]日報表',
    timingTradeBetAmountFee: '極速交易下單/服務費',
    timingTradeBetPrizePoint: '極速交易獎金/返點',
    rechargeAmountFee: '充值金額/服務費',
    rechargePersonCount: '充值人數/筆數',
    timingTradeUserAndCount: '極速交易人數/筆數',
    firstRechargePersonCount: '首充金額/筆數',
    withdrawAmountFee: '提幣金額/服務費',
    withdrawPersonCount: '提幣人數/筆數',
    exchangeAmountFee: '兌換金額/服務費'
  },
  share: {
    title: '我要分享',
    qrCodeLabel: '二維碼',
    registerUrlLabel: '註冊地址',
    inviteCodeLabel: '邀請碼',
    hasNoInviteCode: '當前賬戶沒有邀請碼,',
    generateInvitationCode: '試試一鍵生成',
    tipsPart1: '掃描以上二維碼填寫註冊信息進行註冊',
    tipsPart2: '複製註冊地址填寫註冊信息進行註冊',
    tipsPart3: '手動打開本站點註冊界面填寫邀請碼進行註冊',
    saveImageError: '圖片保存失敗，試試長按圖片並保存'
  },
  myTeam: {
    title: '我的團隊',
    usernamePlaceholder: '輸入下級用戶名',
    point: '返點(極速/合約)',
    totalBalance: '餘額',
    lastLoginTime: '上次登錄時間',
    noLoginTime: '無'
  },
  userDetail: {
    username: '用戶名',
    userType: '用戶類型',
    title: '用戶詳情',
    pointPercentTiming: '極速交易返點',
    pointPercentContract: '合約交易返點',
    registerWay: '註冊方式',
    teamCounts: '團隊人數',
    teamOnline: '團隊在線',
    balance: '餘額',
    registerTime: '註冊時間',
    onlineStatus: '登錄狀態'
  },
  addUser: {
    title: '新增用戶',
    addUserDirect: {
      userTypeLabel: '用戶類型',
      usernameLabel: '用戶名',
      usernamePlaceholder: '請輸入開戶用戶名',
      pointTimingLabel: '極速交易返點',
      pointContractLabel: '合約交易返點',
      tips: '初始密碼為: "{password}"; 開戶後請及時提醒用戶修改密碼',
      userTypeRequired: '請選擇開戶類型',
      usernameRequired: '請輸入開戶用戶名',
      pointTimingRequired: '請選擇極速交易返點',
      pointContractRequired: '請選擇合約交易返點',
      copyTemplate: `
        用戶名: {username};
        登錄密碼: {loginPassword};
        登錄網址: {loginAddress};
        極速交易返點: {timingTradePoint};
        合約交易返點: {contactTradePoint};
        `
    }
  },
  recharge: {
    title: '充幣',
    configIdLabel: '充幣通道',
    chainNameLabel: '鏈名稱',
    amountLabel: '充值金額',
    userCardNameLabel: '付款人',
    userCardNamePlaceholder: '請輸入付款人姓名',
    fee: '服務費',
    receiveAmountTipsPart1: '充值',
    receiveAmountTipsPart2: ', 需支付',
    tipsPart1: '因為在線支付接口不穩定，目前僅支持線下轉賬充值！ ',
    tipsPart2: '請如實填寫實際轉賬金額，否則可能導致系統審核無法通過，影響充值進度。 ',
    emptyPart1: '暫無可用的充值通道, ',
    emptyPart2: '輕觸重試',
    amountRequired: '充值金額不能為空',
    maxPrecisionError: '充值金額最多{amountMaxPrecision}位小數',
    payUserNameError: '請輸入正確的付款人後重試',
    userMobileLabel: '手機號',
    userMobilePlaceholder: '請輸入用戶手機號',
    needPayLabel: '需支付',
    needPayPlaceholder: '點擊輸入金額'
  },
  payDetail: {
    title: '轉賬信息',
    addressLabel: '充幣地址',
    rechargeAmount: '充幣金額',
    bankNameLabel: '銀行',
    branchLabel: '支行地址',
    cardName: '姓名',
    cardNum: '卡號',
    uploadImgLabel: '支付憑證',
    uploadImgPlaceholder: '點擊上傳支付憑證圖片',
    uploadImgRequired: '請上傳支付憑證圖片',
    vcTransferTipsPart1: '1. 複製充幣地址或掃描二維碼進行充幣',
    vcTransferTipsPart2: '2. 充幣完成後上傳支付憑證圖片',
    vcTransferTipsPart3: '為提高充幣的效率, 請確保上傳清晰高清的憑證圖片, 如相關信息圖片不清晰可能導致系統審核無法通過，影響充值進度。 ',
    bankCardTips: '為提高充幣的效率, 請確保使用填寫的轉賬人與匯款人名稱一致; 如相關信息不符合可能導致系統審核無法通過，影響充值進度。 ',
    bankCardTransferSuccess: '我已轉賬成功'
  },
  rechargeOrder: {
    title: '充幣訂單',
    payAmount: '充值金額',
    receiveAmount: '到賬金額'
  },
  identity: {
    title: '實名信息',
    subTitle: '實名認證包括信息認證, 身份認證',
    name: '姓名',
    idType: '證件類型',
    idNum: '證件號碼',
    demand: '要求',
    informationVer: '信息認證',
    idAuthentication: '身份認證',
    material: '材料'
  },
  verified: {
    title: '實名認證',
    idCardTypeLabel: '證件類型',
    idCardFrontSideImgLabel: '證件照正面',
    idCardBackSideImgLabel: '證件照背面',
    idCardHandSideImgLabel: '手持證件照',
    nameLabel: '證件姓名',
    namePlaceholder: '請輸入你的證件姓名',
    idCardNumLabel: '證件號碼',
    idCardNumPlaceholder: '請輸入證件號碼',
    fundPwdLabel: '資金密碼',
    fundPwdPlaceholder: '請輸入你的資金密碼',
    tips: '信息認證一旦提交，不可修改，請謹慎核對後正確填入',
    idCardTypeRequired: '請選擇證件類型',
    idCardFrontSideImgRequired: '請上傳證件正面照',
    idCardBackSideImgRequired: '請上傳證件背面照',
    idCardHandSideImgRequired: '請上傳手持證件照',
    nameRequired: '請輸入證件姓名',
    idCardNumRequired: '請輸入證件號碼',
    fundPwdRequired: '請輸入你的資金密碼',
    submitSuccess: '認證請求提交成功'
  },
  help: {
    title: '幫助中心'
  },
  helpDetail: {
    title: '幫助詳情'
  },
  myMessage: {
    title: '我的私信'
  },
  messageDetail: {
    title: '私信詳情'
  },
  withdraw: {
    title: '提幣',
    tips: '為保證資金安全及提現效率; 請仔細核對所填寫信息無誤, 提幣過程中產生的手續費將從餘額中扣除',
    receiveAmountTipsPart1: '提現',
    receiveAmountTipsPart2: ', 預計到賬',
    fee: '服務費',
    myBalance: '我的 [ {vcName} ] 餘額:',
    configIdLabel: '提幣通道',
    amountLabel: '提幣金額',
    fundLabel: '資金密碼',
    fundPlaceholder: '請輸入你的資金密碼',
    googleCodeLabel: '谷歌驗證碼',
    googleCodePlaceholder: '請輸入6位谷歌驗證碼',
    maxPrecisionError: '提幣金額最多{amountMaxPrecision}位小數',
    amountRequired: '請輸入或選擇正確的提幣金額',
    bankCardError: '請選擇正確的銀行卡',
    fundPwdError: '請輸入正確的資金密碼',
    walletAddressError: '請選擇正確的錢包地址',
    success: '提現請求提交成功, 請等待處理',
    emptyPart1: '暫無可用的提幣通道, ',
    emptyPart2: '輕觸重試'
  },
  withdrawOrder: {
    title: '提幣訂單',
    requestAmount: '提單金額',
    receiveAmount: '到賬金額'
  },
  locales: {
    title: '切換語言'
  },
  lines: {
    title: '線路選擇',
    switchLine: '切換線路'
  },
  currencyPop: {
    deleteFavoriteSuccess: '刪除自選幣成功',
    addFavoriteSuccess: '添加自選幣成功'
  },
  currencySelect: {
    currencyName: '幣種',
    currencyPlaceholder: '點擊選擇幣種'
  },
  walletItem: {
    available: '可用',
    convert: '折合(USDT)'
  },
  banks: {
    bankIdLabel: '銀行',
    bankIdPlaceholder: '點擊選擇銀行'
  },
  banksPop: {
    title: '選擇銀行',
    search: '輸入銀行關鍵字'
  },
  historyOrderDetail: {
    title: '訂單詳情',
    coin: '交易幣種',
    amount: '下單金額',
    buyInClose: '買入價',
    sellOutClose: '賣出價',
    isQuest: '對此訂單有疑問?',
    connectCustomer: '聯繫客服?'
  },
  pointSelect: {
    prizeGroupPlaceholder: '點擊選擇用戶返點'
  },
  walletAddressSelect: {
    title: '選擇錢包地址',
    label: '錢包地址',
    placeholder: '點擊選擇錢包地址'
  },
  myCardSelect: {
    title: '選擇賬戶',
    label: '收款賬戶',
    placeholder: '點擊選擇賬戶'
  },
  amountInput: {
    amountRange: '最小 {minAmount}, 最大{maxAmount}',
    amountMin: '最小 {minAmount}, 上不封頂',
    amountErrorEmpty: '{label}有誤, 請核實後重試',
    amountErrorOutRange: '{label}超出範圍, 請核實後重試'
  },
  amountFormItem: {
    placeholderOnlyMin: '最小 {minAmount}, 上不封頂',
    placeholderHasMax: '最小 {minAmount}, 最大{maxAmount}',
    amountErrorEmpty: '金額有誤, 請核實後重試',
    amountErrorOutRange: '金額超出範圍, 請核實後重試'
  },
  common: {
    remark: '備註',
    saveImage: '保存本地',
    online: '在線',
    offline: '已下線',
    profit: '盈虧',
    date: '日期',
    period: '週期',
    pointAmount: '用戶返點金額',
    point: '用戶返點',
    direction: '方向',
    winLoss: '收益',
    lose: '輸',
    add: '新增',
    win: '贏',
    edit: '修改',
    notBind: '未綁定',
    alreadyBind: '已綁定',
    enabled: '已啟用',
    notEnabled: '未啟用',
    queryRange: '查詢範圍',
    copy: '複製',
    orderNum: '訂單號',
    null: '無',
    noData: '暫無數據',
    refreshSuccess: '刷新成功',
    loadMoreData: '加載更多數據',
    noMoreData: '沒有更多數據了',
    lookMore: '查看更多',
    more: '更多'
  },
  date: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '近7天',
    last14Days: '近14天',
    split: '至'
  },
  button: {
    save: '保存',
    logout: '登出',
    confirm: '確定',
    cancel: '取消',
    submit: '提交',
    addNow: '立即添加',
    reset: '重置',
    nextStep: '下一步',
    goCertification: '去認證'
  },
  confirm: {
    title: {
      logout: '退出登錄',
      unBindFundPassword: '未綁定資金密碼',
      addUserDirect: '新增用戶',
      addUserInfo: '新增用戶成功',
      jumpToRechargePage: '確認跳轉',
      unAuthentication: '未實名認證',
      noBindBankCard: '未添加銀行卡',
      noBindCoinAddress: '未添加錢包地址',
      tradeConfirm: '確認交易',
      sellOutSpotOrder: '持倉賣出',
      buyFinance: '確認購買',
      redeemOrder: '质押订单赎回'
    },
    content: {
      logout: '是否確認退出當前賬號?',
      unBindFundPassword: '檢測到未綁定資金密碼, 為保證賬號安全，請先綁定你的資金密碼',
      addUserDirect: '即將新增用戶, 請核實填寫信息無誤後點擊確認繼續, 用戶名[ {username} ], 用戶類型[ {userType} ], 登錄密碼[ {password} ], 與我的極速交易返點差額[ {diffPointTiming} ], 與我的合約交易返點差額[ {diffPointContract} ]',
      addUserInfo: '用戶名[ {username} ]; <br /> 登錄密碼[ {password} ];<br /> 登錄網址[ {loginAddress} ];<br /> 極速交易返點[ {pointPercentTiming} ];<br /> 合約交易返點[ {pointPercentContract} ]；',
      jumpToRechargePage: '即將跳轉三方充值界面，請點擊確認繼續',
      unAuthentication: '檢測到賬戶沒有進行實名認證， 為保證資金正常流通， 請先進行實名認證',
      noBindBankCard: '檢測到賬戶沒有綁定或啟用的銀行卡，為保證資金正常流通，請先添加銀行卡',
      noBindCoinAddress: '檢測到賬戶沒有綁定或啟用的虛擬幣賬戶，為保證資金正常流通，請先添加虛擬幣賬戶地址',
      tradeConfirm: '即將提交訂單, 請核實訂單信息無誤後點擊確認訂單進行提交',
      sellOutSpotOrder: '即將賣出持倉訂單, 請確認操作無誤後點擊確認繼續',
      buyFinance: '即將買入[{coin}], 買入份額: {amount}, 請確認操作無誤後點擊確認繼續',
      redeemOrder: '质押订单赎回'
    }
  },
  message: {
    bindSuccess: '綁定成功',
    successOperation: '操作成功',
    logoutSuccess: '退出成功',
    editSuccess: '修改成功',
    addSuccess: '修改成功',
    copySuccess: '複製成功',
    copyFailed: '複製失敗'
  },
  vux: {
    'inline-calendar': {
      week_day_0: '日',
      week_day_1: '一',
      week_day_2: '二',
      week_day_3: '三',
      week_day_4: '四',
      week_day_5: '五',
      week_day_6: '六'
    },
    loading: {
      loading: '加載中'
    }
  },
  helpItems: {
    title: {
      part1: '資產中的折合金額為什麼會產生變化？ ',
      part2: '忘記OTC交易的資金密碼處理辦法',
      part3: 'OTC交易買入完成後的資金流向哪裡？ ',
      part4: '為什麼要限制修改暱稱的次數',
      part5: '劃轉是什麼意思，為什麼需要劃轉',
      part6: '如何計算用戶合約的賬戶權益？ ',
      part7: '開倉中設定的止損止盈的數值作用是什麼？應當如何設定？ ',
      part8: '如何降低合約風險度？ ',
      part9: '合約開倉中的數量表示什麼？ ',
      part10: '關於強制平倉的說明',
      part11: '合約交易規則是什麼？ ',
      part12: '合約交易中的保證金是什麼？ ',
      part13: '什麼是限價委託和市價委託？ ',
      part14: '合約交易的風險度代表什麼',
      part15: '為什麼需要進行幣種兌換？ ',
      part16: '為什麼在OTC交易轉賬後，對方未及時收到轉款？ ',
      part17: '如何通過OTC購買泰達幣（USDT）？ '
    },
    content: {
      part1: '資產中折合計算的時當前持有數字貨幣折合人名幣的價值，因數字資產的價格波動而變化。您的數字資產數量並沒有改變。 ',
      part2: '如果你忘記OTC交易資金密碼，請到“我的-設置-點擊設置資金密碼”或聯繫客服進行重置',
      part3: 'OTC買入訂單完成後，資金將進入資產中的法幣賬戶。若需要將OTC買入資產進行合約交易或期貨交易，請至資金劃轉模塊進行劃轉。 ',
      part4: '出於您交易的安全原因，目前我們限制暱稱只能修改一次。 ',
      part5: '為了保障您的各個賬戶之間的資金獨立，有利於您進行合理的風險控制，特此將各大交易模塊的賬戶進行劃分。劃轉是指各個交易賬戶之間的資產進行互相轉換的過程。 ',
      part6: '<p>合約賬戶權益，計算方法如下：</p> <p>合約賬戶權益=持倉保證金+持倉浮動盈虧+當前賬戶可用金額</p>',
      part7: '止盈止損作為您設定的盈利上限和損失上限，達到設定的止盈止損金額，系統將自動平倉。可用於您在購買合約時的風險控制，一半設定的止盈數額為：漲幅金額x數量x槓桿倍數，設定的止損我們建議您根據自己的實際資產情況進行設定，合理控制風險。 ',
      part8: '您可以通過資金劃轉的方式，將其餘賬戶的可用資產劃入合約賬戶，或通過減少持倉，來降低風險度。 ',
      part9: '開倉中的數量表示您期望買入的幣種數量。例如：在BTC/USDT交易對的開倉頁面中選擇，買入做多，輸入價格為1000USDT，輸入數量為10BTC，則表示：您期望買入10個單價為1000USDT的BTC。 ',
      part10: '<p>風險度是衡量您的資產風險的指標，當風險度等於100%時，您的倉位被視為爆倉，風險度=（持倉保證金/合約賬戶權益）*100%，為了防止用戶穿倉，系統設定了風險度的調整比例，當風險度達到系統設定的風險值，系統將強制平倉。例如：系統設定的調整比例為10%，則當您的風險度大於等於90%時，您的所有倉位都將會被系統強制平倉。 </p> <p>注：若是風險度超標導致的系統強制平倉，是將您所有倉位都進行平倉，因此希望您可以合理的控制您的風險度，以免因此造成不必要的損失 </p>',
      part11: '<p> 交易類型</p> <p>交易類型分為開倉做多（買入）和開倉做空（賣出）兩個方向：</p> <p>買入做多（看漲）是指您認為當前指數有漲的可能，希望以您設定的價格或者當前市價，新買入一定數量的某種合約。 </p> <p>賣出做空（看跌）是指您認為當前指數有跌的可能，希望以您設定的價格或當前市價，新賣出一定數量的某種合約。 </p> <p>下單方式</p> <p>限價委託：您需要自己指定下單的價格和數量</p> <p>市價委託：您只需設定下單的數量，價格為當前市場價格</p> <p>持倉</p> <p>當您提交的開倉委託單成交後即稱之為持倉</p> <p>合約交割問題</p> <p>平台合約為永續合約，無設定交割時間。只要未達到系統爆倉條件或您 未手動平倉，您可永久持倉。 </p> <p>系統平倉</p> <p>1：達到止盈止損設定值，系統自動平倉</p> <p>2：風險度過高，系統強制平倉</p>',
      part12: '<p>在合約交易中，用戶根據合約價格和數量，根據對應的槓桿倍數，繳納資金作為欸履行合約的財力擔保，便可參與合約的買賣，這種資金就是合約保證金。用戶開倉將佔用保證金，佔用的開倉保證金越多，賬戶風險越高。 </p> <p>保證金=（開倉價格*數量）/槓桿倍數</p>',
      part13: '限價委託指的是您期望以什麼價格委託平台進行交易，市價委託是指直接以當前價格委託平台進行交易。在開倉交易的規則中，市價委託是優先於限價委託進行交易的。若您選擇限價委託請合理根據當前貨幣的行情價格進行開倉，避免因不合理的開倉價格造成損失。 ',
      part14: '風險度是您合約賬戶中風險指標，風險度等於100%被視為爆倉。我們建議您，當您的風險度超過50%時，需要謹慎開倉，以免因為爆倉而造成損失。可通過補充合約資產的可用資金，或減少持倉來降低您的風險。 ',
      part15: '兌換的作用是為了讓您的資產中不同幣種的資金可以進行順暢的流通，期貨賬戶中獲得的QCC可自由轉換成USDT進行交易。其他賬戶中的USDT也可自由的轉換成QCC進行交易。 ',
      part16: '首先請確保您轉賬時填寫的收款方式和訂單詳情頁的顯示的完全一致。然後請確認您的付款方式是即時到賬的，還是延遲到賬的。最後請聯繫您的銀行和支付機構，是否有系統維護或其他原因。 ',
      part17: '<p>方式一：通過OTC購買和售出列表選擇您想要購買的訂單進行買賣。 </p> <p>方式二：點擊發布按鈕，根據自己的需求發布買單或者賣單進行快速交易。系統將快速為您匹配買賣用戶。 </p> <p>注：買入訂單在15分鐘後若未支付，系統將自動取消訂單，請您及時支付。若當日取消訂單超過3次，當日無法再次進行交易，次日恢復交易權限。 </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/zh-TW.js